import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import "./breadcrumb.css";

class BreadCrumpBack extends Component {
  handleBack = () => {
   window.history.go(-1);
  };

  render() {
    return (
      <div className="breadcrumb-wrapper2">
        <div className="container p-0">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={"/"}>
                <i className="fa fa-home"></i>
                Home
              </Link>
            </li>
            <li className="breadcrumb-item selactive">
              <Link to={"#"} onClick={this.handleBack}>
                <i className="fa fa-arrow-left"></i>
                Back
              </Link>
            </li>
          </ol>
        </div>
      </div>
    );
  }
}

export default BreadCrumpBack;
